import React from 'react';

const WorkerValuationsList = ({ monthlyValuations, renderRatingsAndQuestions }) => {
  return (
    <ul className='worker-details-list'>
      {monthlyValuations.map((valuation) => (
        <li key={valuation.id}>
          <h2 className='case-title'>Dato: {valuation.month}</h2>
          {renderRatingsAndQuestions(valuation.ratings, valuation.questionsAnswered)}
        </li>
      ))}
    </ul>
  );
};

export default WorkerValuationsList;
